import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, LaptopIcon } from 'lucide-react';
type TrustLineProps = {
  tone?: 'light' | 'dark';
  includeDigital?: boolean;
  className?: string;
};

/** The risk-reducing microcopy that must sit under every CTA. */
export function TrustLine({
  tone = 'light',
  includeDigital = false,
  className = ''
}: TrustLineProps) {
  const items = [{
    Icon: LockIcon,
    label: 'Secure checkout'
  }, {
    Icon: ZapIcon,
    label: 'Instant download'
  }, {
    Icon: ShieldCheckIcon,
    label: '7-day guarantee'
  }, ...(includeDigital ? [{
    Icon: LaptopIcon,
    label: '100% digital (PDF)'
  }] : [])];
  const text = tone === 'dark' ? 'text-white/75' : 'text-sage-deep';
  const icon = tone === 'dark' ? 'text-white/60' : 'text-sage';
  return <ul className={`flex flex-wrap items-center gap-x-5 gap-y-2 text-[13px] font-medium ${text} ${className}`} data-id="element-220" data-mp="106mclhils77z">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5" data-id="element-221" data-mp="vel2o28wqsl4">
          <Icon className={`w-3.5 h-3.5 ${icon}`} aria-hidden="true" data-id="element-222" data-mp="3kvplkugy27ld" />
          {label}
        </li>)}
    </ul>;
}